import { updateElementVisibility } from "./updateElementVisibility";

interface ShowOrHideElementsParams {
	elements: (HTMLElement | null)[] | HTMLElement | NodeListOf<HTMLElement> | null;
	show?: boolean;
	displayValue?: string;
	important?: boolean;
}

export function showOrHideElements({
	elements,
	show = true,
	displayValue = "block",
	important = false,
}: ShowOrHideElementsParams) {
	if (!elements) {
		return null;
	}
	const visibility = show ? displayValue : important ? "none !important" : "none";

	if (Array.isArray(elements) || elements instanceof NodeList) {
		for (const element of elements) {
			if (element) {
				updateElementVisibility(element, show, visibility);
			}
		}
	} else if (elements) {
		if (elements) {
			updateElementVisibility(elements, show, visibility);
		}
	}
}
